/**
 * Relay-style Apollo merge for `{ edges, pageInfo, totalCount }` connections.
 * Preserves the existing workspace behavior: append when `after` is set,
 * otherwise replace the cached page.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeEdgesConnection = (
  existing: any,
  incoming: any,
  options: { args?: Record<string, any> | null }
) => {
  const after =
    options && options.args && typeof options.args.after !== 'undefined'
      ? options.args.after
      : undefined;
  if (!incoming) return existing;
  if (!existing || !after) return incoming;
  return {
    ...incoming,
    edges: [...(existing.edges ?? []), ...(incoming.edges ?? [])],
    pageInfo: incoming.pageInfo,
    totalCount: incoming.totalCount
  };
};

/**
 * Existing inbound-call merge behavior. It is intentionally separate from the
 * workspace merge because calls deduplicate edges by cursor.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeUniqueEdgesConnection = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  existing: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  incoming: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: { args?: Record<string, any> | null }
) => {
  const after =
    options && options.args && typeof options.args.after !== 'undefined'
      ? options.args.after
      : undefined;
  if (!incoming) return existing;
  if (!existing || !after) return incoming;

  const edges = [...(existing.edges ?? [])];
  const seenCursors = new Set(edges.map((edge) => edge.cursor));
  for (const edge of incoming.edges ?? []) {
    if (!seenCursors.has(edge.cursor)) {
      seenCursors.add(edge.cursor);
      edges.push(edge);
    }
  }
  return {
    ...incoming,
    edges,
    pageInfo: incoming.pageInfo,
    totalCount: incoming.totalCount
  };
};
